<h2 mat-dialog-title>
    ICD-10 Codes
    <span class="patient-name" *ngIf="data?.patient">
        {{ data.patient.name }} {{ data.patient.surname }}
    </span>
</h2>

<mat-dialog-content>
    <!-- The picker carries the whole editing experience: autocomplete, drag-to-reorder,
         double-click for onset date, and the advisory findings panel. This dialog is a frame
         around it and a save button, deliberately — a second implementation of any of that is
         how the file card and the picker drifted apart in the first place. -->
    <app-icd-code-selector #selector [initialCodes]="initialCodes" [isRequired]="true"
        [patientSex]="patientSex" [patientAge]="patientAge" [defaultOnsetDate]="defaultOnsetDate"
        (codesChanged)="onCodesChanged($event)"></app-icd-code-selector>

    <!-- No hint of its own. The picker already carries one under the field ("First code is
         primary — drag to reorder…"), and a second line saying the same thing a few hundred
         pixels lower read as two different instructions and crowded the findings panel between
         them. -->

    <div class="save-error" *ngIf="errorMessage">
        <mat-icon>error_outline</mat-icon>
        <span>{{ errorMessage }}</span>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()" [disabled]="saving">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="!canSave">
        <mat-icon *ngIf="saving" class="saving-spinner">hourglass_empty</mat-icon>
        {{ saving ? 'Saving…' : 'Save Codes' }}
    </button>
</mat-dialog-actions>
